import React, {useEffect, useState, useRef} from "react";
import brands1 from '../assets/images/brands1.jpg';
import {Link, Redirect} from "react-router-dom";
import logo from '../assets/images/logo.svg';
import Footer from "./Footer";
import sia from "../services/Api";
import {notifyErrorMessage} from "../App";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'
import LoaderView from "../tools/LoaderView";
import TopNav from "./TopNav";
import KhatmSalavat from "./KhatmSalavat";

const KhatmArchive = (props) => {

    const [isLoading, setLoading] = useState(true)
    const [responseData, setResponseData] = useState(true)
    const isMine = useRef(false)

    useEffect(() => {
        const search = props.location.search
        const params = new URLSearchParams(search)
        isMine.current = params?.get('mine')
        console.log(isMine.current)
        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        await sia.getDataFromServer(isMine ? 'myFuneral?my_archive=true' : 'funeral').then((res) => {
            if (res.status == 200) {
                setResponseData(res.data)
            }
        }).catch((err) => notifyErrorMessage(err))
        setLoading(false)
    }

    const formSubmit = (e) => {
        e.preventDefault();
        window.location.href = link;
    }

    const [link, setLink] = useState('')

    return (
        <>
            <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
            <header>
                <div className="pagewrapper slim2" id="header-slim">
                    <div className="container">
                        <TopNav/>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            {/* <div className="pagewrapper" id="statistics">
                <div className="container">
                    <div className="right-col">
                        <div className="stat-item box-sizing">
                            <span>10</span>
                            ختم فعال
                        </div>
                        <div className="stat-item border0 box-sizing">
                            <span>1</span>
                            شرکت کننده
                        </div>
                    </div>
                    <div className="pinbar" />
                    <div className="left-col">
                        <div className="stat-item box-sizing">
                            <span>4</span>
                            ختم تمام شده
                        </div>
                        <div className="stat-item box-sizing">
                            <span>3</span>
                            خوانده شده
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="pagewrapper" id="center-search">
                <div className="container">
                    <form action id="center-search-form" method="get" onSubmit={formSubmit} action={link}>
                        <input type="text" value={link} onChange={(e) => setLink(e.target.value)}
                               placeholder="لینک ختم را اینجا وارد کنید" className="text radius50 box-sizing"/>
                        <a href="link"><input type="submit" value="جستجو" className="btn ease radius50"/></a>
                    </form>
                    <a onClick={() => window.location = './new-khatm'} title
                       className="clickable link-btn ease box-sizing radius50">ایجاد ختم جدید</a>
                </div>
            </div>
            <div className="pagewrapper" id="khatm-list">
                <div className="container">
                    {isLoading ? <LoaderView/> : <ul className="list-items">
                        {responseData.map((item) => <li onClick={() => {
                            if (item.type == "3") {
                                window.location = './khatm-salavat?id=' + item._id
                            } else {
                                window.location = './khatm?id=' + item._id
                            }
                        }} className="clickable item box-sizing radius10">
                            <h3 className="title pb-3">ختم {function () {
                                switch (item.type) {
                                    case "1":
                                        return 'قرآن'
                                    case "2":
                                        return 'ادعیه'
                                    case "3":
                                        return 'صلوات'
                                    case "4":
                                        return 'جزء'
                                    case "5":
                                        return 'سوره'
                                    default:
                                        return item.type
                                }
                            }()}</h3>
                            {/* <h4 className="desc">شادی روح علی انصاریان</h4> */}
                            <div className="details box-sizing radius10">
                                <p className="detail-item box-sizing">تعداد کل:<span
                                    className="number">{item.repeat}</span></p>
                                <p className="detail-item box-sizing">خوانده شده:<span
                                    className="number">
                                {/*    {if(item.shomarsh && item.shomarsh.length > 0){*/}
                                {/*        return item.shomarsh[0].count;*/}
                                {/*        else{*/}

                                {/*}*/}
                                {/*} ?  : 0}*/}
                                </span>
                                </p>
                                <p className="detail-item box-sizing">مانده:<span
                                    className="number">{item.repeat - (item.shomarsh && item.shomarsh.length > 0 ? item.shomarsh[0].count : 0)}</span>
                                </p>
                            </div>
                        </li>)}
                    </ul>}
                </div>
            </div>
            <div className="clear"/>
            <Footer/>
        </>
    );
}

export default KhatmArchive;